/* Renaissance Afro v4 — titres mot à mot, images masquées, 2e photo au survol, cartes ingrédients, barre d'achat */
(function () {
  'use strict';
  var html = document.documentElement;
  var motion = html.classList.contains('ra-motion');

  function observe(els, cb, opts) {
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(cb); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { cb(e.target); io.unobserve(e.target); } });
    }, opts || { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* 1. Titres révélés mot à mot */
  if (motion) {
    var heads = document.querySelectorAll('.ra-hero h1, .ra-intro h2, .ra-story h2, .ra-ritual h2, .ra-help h2, .ra-faq__head h2, .ra-types__head h2, .ra-ingr__head h2, .ra-collection-heading h1, .product-list h2');
    var list = [];
    heads.forEach(function (h) {
      if (h.dataset.raSplit) return;
      h.dataset.raSplit = '1';
      var n = 0;
      var walk = function (node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (c) {
          if (c.nodeType === 3) {
            var parts = c.textContent.split(/(\s+)/);
            var frag = document.createDocumentFragment();
            parts.forEach(function (p) {
              if (!p) return;
              if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
              var w = document.createElement('span'); w.className = 'ra-w';
              var i = document.createElement('span'); i.className = 'ra-wi'; i.textContent = p;
              i.style.setProperty('--w', n++);
              w.appendChild(i); frag.appendChild(w);
            });
            c.parentNode.replaceChild(frag, c);
          } else if (c.nodeType === 1 && c.tagName !== 'BR') { walk(c); }
        });
      };
      walk(h);
      h.classList.remove('ra-reveal');
      h.classList.add('ra-split');
      var r = h.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92) { requestAnimationFrame(function () { requestAnimationFrame(function () { h.classList.add('ra-in'); }); }); }
      else list.push(h);
    });
    observe(list, function (el) { el.classList.add('ra-in'); });

    /* 2. Images dévoilées par un masque */
    var masks = document.querySelectorAll('.ra-story__media, .ra-step__media, .ra-type__media');
    var ml = [];
    masks.forEach(function (m) { m.classList.add('ra-mask'); ml.push(m); });
    observe(ml, function (el) { el.classList.add('ra-in'); }, { rootMargin: '0px 0px -6% 0px', threshold: 0.1 });

    /* Encart routine : reflet lumineux à l'arrivée */
    observe(Array.prototype.slice.call(document.querySelectorAll('.ra-upsell')), function (el) { el.classList.add('ra-in'); });
  }

  /* 3. Cartes produit : 2e photo au survol */
  if (window.matchMedia('(hover: hover)').matches) {
    document.querySelectorAll('.product-card').forEach(function (card) {
      if (card.dataset.raAlt) return;
      var imgs = card.querySelectorAll('img');
      if (imgs.length < 2) return;
      var second = imgs[1];
      var holder = imgs[0].parentElement;
      if (!holder) return;
      var alt = document.createElement('img');
      alt.className = 'ra-card-alt'; alt.alt = ''; alt.loading = 'lazy'; alt.setAttribute('aria-hidden', 'true');
      if (second.getAttribute('srcset')) alt.setAttribute('srcset', second.getAttribute('srcset'));
      alt.src = second.getAttribute('src') || second.currentSrc || '';
      alt.sizes = imgs[0].sizes || '30vw';
      if (getComputedStyle(holder).position === 'static') holder.style.position = 'relative';
      holder.appendChild(alt);
      card.dataset.raAlt = '1';
    });
  }

  /* 4. Cartes ingrédients : retournement au toucher / clavier */
  document.querySelectorAll('.ra-flip').forEach(function (card) {
    card.addEventListener('click', function () {
      var on = card.classList.toggle('is-flipped');
      card.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  });

  /* 5. Barre d'achat collante (fiche produit) */
  var bar = document.querySelector('[data-ra-sticky]');
  if (bar) {
    var form = document.querySelector('product-information form[action*="/cart/add"], .product-information form[action*="/cart/add"], form[action*="/cart/add"]');
    var target = form ? (form.closest('buy-buttons-component, .buy-buttons-block, product-form-component') || form) : null;
    var btn = bar.querySelector('[data-ra-sticky-add]');
    var footer = document.querySelector('.ra-footer, footer');
    var aboveFold = true, footerIn = false;
    var sync = function () {
      var show = !aboveFold && !footerIn;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (btn) btn.tabIndex = show ? 0 : -1;
    };
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0];
        aboveFold = e.isIntersecting || e.boundingClientRect.top > 0;
        sync();
      }, { threshold: 0 }).observe(target);
      if (footer) new IntersectionObserver(function (en) { footerIn = en[0].isIntersecting; sync(); }, { threshold: 0 }).observe(footer);
    }
    if (btn) btn.addEventListener('click', function () {
      var submit = form && form.querySelector('[type="submit"]:not([disabled]), button[name="add"]:not([disabled])');
      if (submit) { submit.click(); }
      else if (target) { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
  }
})();
